import { useEffect, useState } from "react";

type ViewportMode = 'desktop' | 'tablet' | 'mobile';

export const useViewportMode = () => {
  const [mode, setMode] = useState<ViewportMode>('desktop');

  useEffect(() => {
    const checkMode = () => {
      const width = window.innerWidth;
      if (width <= 500) {
        setMode('mobile');
      } else if (width <= 768) {
        setMode('tablet');
      } else {
        setMode('desktop');
      }
    };

    checkMode();
    window.addEventListener('resize', checkMode);
    return () => window.removeEventListener('resize', checkMode);
  }, []);

  return {
    mode,
    isMobile: mode === 'mobile',
    isTablet: mode === 'tablet',
    isDesktop: mode === 'desktop',
  };
};

const useMobileDetection = () => {
  const { isDesktop } = useViewportMode();
  return !isDesktop;
};

export default useMobileDetection;
